<template minapp="mpx" xlang="wxml">
  <view class="train-order-information-occupying" wx:if="{{!hasSeat}}">
    <block wx:for="{{order.tickets_info}}">
      <view class="item">
        <view class="left">
          <view class="name">{{ item.passenger_name }}</view>
          <view class="state-card">
            <view class="card" wx:if="{{item.ticket_type}}">{{ getType(item) }}</view>
          </view>
        </view>
        <view class="seat">{{ item.seat_type }} {{price(item)}}</view>
      </view>
      <view class="line" wx:if="{{index!= order.tickets_info.length-1}}"></view>
    </block>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import store from '@/store'
import { getFinalPrice } from '@/utils/money'

createComponent({
  props: {
    order: {
      type: Object
    },
    hasSeat: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    getType(item) {
      const type = +item?.ticket_type || 1
      return type == 3 ? '学生票' : type === 2 ? '儿童票' : '成人票'
    },
    price(item) {
      const _price = getFinalPrice(+item.ticket_price || item.personal_pay)
      return `¥${_price}`
    },
  }
})
</script>

<style lang="stylus" scoped>
@import '~@/mixins/stylus/color.styl'

.train-order-information-occupying
  position relative
  display flex
  flex-direction column
  align-items center
  background #d2e6ff
  padding-top 25px
  margin-top -25px
  border-radius 10px
.item
  display flex
  height 42px
  width 100%
  padding 14px 16px
  justify-content space-between
  box-sizing border-box
  flex-direction row
  .left
    display flex
  .name
    font-family PingFang SC
    font-weight 500
    font-size 15px
    line-height 15px
    letter-spacing 0px
    color #222
  .seat
    font-family PingFang SC
    font-size 15px
    font-weight 500
    line-height 15px
    text-align right
    letter-spacing 0px
    color #222
.line
  width 327px
  height 0.5px
  background #ADCAEE
.state-card
  display flex
  align-items center
  .card
    position relative
    box-sizing border-box
    padding 2px
    margin-left 4px
    border-radius 3px
    font-family PingFangSC-Regular
    font-size 10px
    line-height 10px
    color #5F88C8
    &:after
      position absolute
      content ''
      width 200%
      height 200%
      box-sizing border-box
      border 1px solid #5F88C8
      transform-origin 0 0
      transform scale(0.5)
      border-radius 6px
      top 0
      left 0
</style>

<script name="json">
module.exports = {
  component: true
}
</script>